import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeysPipe } from "./keys.pipe";
import { CheckObjectPipe } from './checkObject.pipe';
import { SimpleIdentifierPipe } from './IdentifierFromString.pipe';


@NgModule({
  declarations: [KeysPipe, CheckObjectPipe, SimpleIdentifierPipe],
  imports: [CommonModule],
  exports: [KeysPipe, CheckObjectPipe, SimpleIdentifierPipe]
})

export class MainPipes { }